import React from "react";

export const StatusIcon = ({ checked, onChange, onClick, disabled }) => {
  return (
    <span
      className="switch switch-sm d-inline-block align-top p-0 ml-2"
      onClick={onClick}
    >
      <label>
        <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
        <span></span>
      </label>
    </span>
  );
};
